import React, { useState, useEffect } from "react";
import {
  CircularProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@mui/material";
import { SlReload } from "react-icons/sl";
import { IoSearchOutline } from "react-icons/io5";

import {
  StyledTableCell,
  StyledTableRow,
} from "../../Components/MaterialTableStyle/StyleTableCell";
import CustomTooltip from "../../Components/Input/CustomToolTip";
import Verce from "../../Assets/images/logo.svg";
import { FormatDate } from "../../Components/DateFormats/DateFromat";
import CustomText_input from "../../Components/Input/CustomText_input";

const WhitelistingTable = ({ WhiteListing , reloadwhitelist }) => {
  const [InitialData, setInitialData] = useState([]);
  const [Loader, setLoader] = useState(false);
  const [SearchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    setInitialData(WhiteListing);
    setLoader(true);
  }, [WhiteListing]);

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [Loader]);

  const HandleSearch = (e) => {
    const Datas = [...WhiteListing];
    setSearchQuery(e);
    let filetedsearch = Datas.filter(
      (a) =>
        a.toLowerCase().includes(e?.toLowerCase()));
    setInitialData(filetedsearch);
  };
  
  return (
    <Grid
      container
      lg={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"flex-start"}
      justifyContent={"flex-start"}
  
      className="p-4"
    >
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item lg={6}>
          <h5 className="text-left">Whitelisted Addresses</h5>
        </Grid>
        <Grid
          item
          lg={6}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid item sm={6} xs={6}>
            <CustomText_input
              placeholder={"Search..."}
              isBorder={true}
              borderColor={"#fff"}
              Value={SearchQuery}
              HandleInput={(e) => HandleSearch(e)}
              StartIcon={<IoSearchOutline className="text-light" size={25} />}
              height={"40px"}
            />
          </Grid>
          <Grid item>
            <button
              className="btn  rounded mx-3 btn-0 GlassCard"
              onClick={() => {setLoader(true);reloadwhitelist();}}
            >
              <SlReload color="#FFED8C" size={"22px"} />
            </button>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
        className="mt-2"
      >
        <TableContainer
          className="customeScroll"
          sx={{border: "1px solid #FFFFFF1A",borderRadius:"15px", height: { lg: "40vh", sm: "50vh" }, overflowY: "auto" }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead root>
              <StyledTableRow>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  No
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Investor Address
                </TableCell>
              </StyledTableRow>
            </TableHead>
            {!Loader ? (
              InitialData?.length > 0 ? (
                <TableBody>
                  {InitialData?.map((row, i) => (
                    <StyledTableRow key={i} sx={{backgroundColor:i % 2 !== 0 ? "#FFFFFF0F" : "#343435CC",}}>
                      <StyledTableCell className="text-center">
                        <span>{i + 1}</span>
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTooltip
                          title={row}
                          placement="right"
                        >
                          <span>
                            {row}
                          </span>
                        </CustomTooltip>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      <p className="text-center text-light">
                        No transactions available
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              )
            ) : (
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <span className="regular">
                      <CircularProgress style={{ color: "#FFFF" }} />
                    </span>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default WhitelistingTable;
